/**
 * Shared redirect map used by TanStack route redirects/server logic.
 *
 * Add new redirects here — they will apply in all environments automatically.
 */
export const redirects: Record<string, string> = {
  "/ja/about": "/ja/company",
  "/en/about": "/en/company",
  "/ja/esports": "/ja/work",
  "/en/esports": "/en/work",
  "/ja/marketing": "/ja/work",
  "/en/marketing": "/en/work",
  "/ja/products": "/ja/work",
  "/en/products": "/en/work",
  "/ja/schedule": "/ja/calendar",
  "/en/schedule": "/en/calendar",
  "/ja/home": "/ja",
  "/en/home": "/en",
}

function normalizeRedirectPath(path: string) {
  const pathname = path.startsWith("http") ? new URL(path).pathname : path.split("?")[0]
  if (pathname !== "/" && pathname.endsWith("/")) return pathname.slice(0, -1)
  return pathname
}

export function getLegacyRedirect(path: string) {
  return redirects[normalizeRedirectPath(path)]
}
